(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vt-overons"] && !Shopify.designMode) return;
  try {
      (function () {
    document.querySelectorAll('[data-ov-dias]').forEach(function (doos) {
      var dias = [].slice.call(doos.querySelectorAll('[data-ov-dia]'));
      if (dias.length < 2) return;

      var sectie = doos.closest('.vt-ov');
      var lijst = sectie.querySelector('[data-ov-tabs]');
      var tabs = lijst ? [].slice.call(lijst.querySelectorAll('[data-ov-tab]')) : [];
      var beelden = [].slice.call(sectie.querySelectorAll('[data-ov-beeld]'));
      var nu = 0;

      function toon(n, focus) {
        nu = (n + dias.length) % dias.length;
        dias.forEach(function (d, i) {
          var aan = i === nu;
          d.classList.toggle('is-aan', aan);
          d.inert = !aan;
          if (aan) d.removeAttribute('aria-hidden'); else d.setAttribute('aria-hidden', 'true');
        });
        beelden.forEach(function (b, i) {
          b.classList.toggle('is-aan', i === nu);
        });
        tabs.forEach(function (tab, i) {
          var aan = i === nu;
          tab.setAttribute('aria-selected', aan ? 'true' : 'false');
          tab.tabIndex = aan ? 0 : -1;
          if (aan && focus) {
            tab.focus();
            tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        });
      }

      dias.forEach(function (d) { d.hidden = false; });
      beelden.forEach(function (b) { b.hidden = false; });
      if (lijst) lijst.hidden = false;
      sectie.classList.add('is-klaar');

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { toon(i); });
      });
      if (lijst) {
        lijst.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = nu + 1;
          if (e.key === 'ArrowLeft') n = nu - 1;
          if (e.key === 'Home') n = 0;
          if (e.key === 'End') n = dias.length - 1;
          if (n === null) return;
          e.preventDefault();
          toon(n, true);
        });
      }

      toon(0);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
